// extracted by mini-css-extract-plugin
module.exports = {"toggle":"SidebarMenuItem_toggle__1jVwJ","submenu":"SidebarMenuItem_submenu__2zc8p","enterMenu":"SidebarMenuItem_enterMenu__2HIs4","active":"SidebarMenuItem_active__2BenG"};